<template>
  <v-layout row wrap justify-end align-center class="checkin-guest-content px-5">
    <v-flex xs12 class="mb-2 ml-2"><guest-name :guest="guest"/></v-flex>
    <v-chip
      v-if="guest.type"
      small
      outlined
      label
      color="secondary"
    >
      {{ guest.type.name }}
    </v-chip>
    <v-spacer/>
    <v-btn
      @click="$emit('click')"
      v-if="!isExempt"
      small
      :class="{'elevation-0': !!status, 'success--text text--darken-2': status === 'COMPLETED'}"
      :color="status === 'COMPLETED' ? '#CDE4E4' : 'primary'"
    >
      <v-icon v-if="status === 'COMPLETED'" color="success" class="mr-2">mdi-check-circle-outline</v-icon>
      {{ $t('actions.checkin_' + status.toLowerCase() )}}
    </v-btn>
    <span v-else class="body-2 grey--text mr-4">{{ $t('checkin.exempt') }}</span>
  </v-layout>
</template>
<script>
export default {
  props: {
    guest: Object,
    isExempt: Boolean,
    status: String,
  },
  components: {
    GuestName: () => import('@/components/app-components/GuestName.vue'),
  },
}
</script>
